export const archetypes = {
  outlaw: {
    name: "叛逆者",
    planet: "冥王星",
    planetImg: "/images/planets/pluto.png",
    color: "#8b4a6b",
    feature: "你是太阳系边缘的流放者，轨道高度椭圆，曾被降级却依然保持着神秘的引力。你天生质疑权威，打破陈规是你的本能。当所有人都在遵守规则时，你会问：'这规则是谁定的？'你不是为了反叛而反叛，而是因为你看到了现有秩序的裂缝，并有勇气指出来。你的存在提醒着世界：变革往往始于那些敢于说'不'的人。",
    alienation: "当叛逆成为习惯，你可能开始为反对而反对。在社交平台上刻意挑衅主流观点，用极端言论获取关注，把愤怒当作唯一的表达方式。你开始享受冲突带来的肾上腺素，却忘了最初反抗的意义。渐渐地，你发现自己陷入了一个悖论：你反对一切，却也被'反对'本身所束缚。",
    vacation: "试着在一周内不发表任何批判性观点，只是观察和倾听。去花鸟市场买一盆需要耐心照料的植物，体验'建设'而非'破坏'的成就感。找一个你曾经激烈反对的观点，认真研究支持它的理由——不是为了认同，而是为了理解。",
  },
  magician: {
    name: "魔法师",
    planet: "海王星",
    planetImg: "/images/planets/neptune.png",
    color: "#5a7a9a",
    feature: "你栖息在梦幻的蓝色星球上，甲烷大气层折射出如梦似幻的光芒。你是愿景的编织者，能看到别人看不到的可能性。当其他人说'这不可能'时，你已经在脑海中构建出实现它的路径。你相信想象力是改变现实的第一步，而你的天赋就是让人们相信那些尚未发生的美好。你是团队里的造梦师，总能在绝望中点燃希望的火花。",
    alienation: "当幻想与现实的边界开始模糊，你可能沉溺于自我编织的美好叙事中。你开始用精心设计的人设替代真实的自己，在不同场合切换不同面具，直到连自己都分不清哪个才是真正的你。你逃避那些不够'梦幻'的现实问题，用'一切都会好的'来麻痹自己和他人，却让问题在暗处持续发酵。",
    vacation: "关掉所有滤镜，用手机原相机拍一张此刻的自己，不修图直接设为头像保持一周。去海边看一场完整的日落，全程不拍照不发朋友圈，只是用眼睛记住。写下三个你一直回避的'不够美好'的现实问题，给每个问题制定一个具体的小行动。",
  },
  hero: {
    name: "英雄",
    planet: "火星",
    planetImg: "/images/planets/mars.png",
    color: "#c44536",
    feature: "你的星球表面覆盖着铁锈红的尘土，那是无数战斗留下的印记。你是天生的行动派，面对挑战时第一个冲上前线。'做还是不做'对你来说从来不是问题，因为答案永远是'做'。你有着强烈的正义感和保护欲，看到不公会本能地站出来。你相信勇气可以战胜一切，而你的存在本身就在告诉周围的人：困难是用来克服的，不是用来逃避的。",
    alienation: "当英雄情结过度膨胀，你开始把所有关系都变成竞技场。同事的成功让你焦虑，朋友的建议听起来像挑战。你习惯性地否定他人来维护自己的'强者'形象，却在深夜独自舔舐那些不敢示人的脆弱。你赢得了很多战斗，却发现身边的战友越来越少。最终你成了一座孤独的丰碑，高大却冰冷。",
    vacation: "参加一次完全匿名的互助小组，只倾听不发言，感受'不需要拯救任何人'的轻松。报名一个陶艺课，允许自己做出丑陋的作品并把它摆在家里。找一件你一直想做但害怕失败的小事，故意用最笨的方法去尝试，体验'过程比结果重要'的感觉。",
  },
  lover: {
    name: "情人",
    planet: "金星",
    planetImg: "/images/planets/venus.png",
    color: "#d4a574",
    feature: "你被浓厚的大气层温柔包裹，是太阳系中最炽热的存在。你天生懂得爱与被爱的艺术，对美有着敏锐的感知力。你相信连接是生命的意义，一段深刻的对话、一个理解的眼神、一次心灵的共振，都能让你感到存在的价值。你是关系中的粘合剂，总能让身边的人感到被珍视。你的世界里，爱不是软弱，而是最强大的力量。",
    alienation: "当对爱的渴望变成依赖，你开始在关系中迷失自我。你过度解读每一条消息的语气，在对方的沉默中脑补出一百种被抛弃的剧情。你学会了察言观色，用讨好换取安全感，却在这个过程中一点点磨掉了自己的棱角。你害怕独处，因为安静下来就会听到内心那个问题：'如果没有人爱我，我还是我吗？'",
    vacation: "独自去一家从未去过的餐厅，点一份完全凭直觉选择的菜，享受'只取悦自己'的用餐体验。列出10件'不需要任何人陪伴也能让你快乐'的事情，这周完成其中3件。给自己写一封情书，认真地、不敷衍地，写下你欣赏自己的地方。",
  },
  caregiver: {
    name: "照顾者",
    planet: "地球",
    planetImg: "/images/planets/earth.png",
    color: "#4a8a6a",
    feature: "你是宇宙中已知唯一孕育生命的星球，蓝色的海洋和绿色的大地是你温柔的证明。你有着与生俱来的共情能力，能敏锐地感知他人的需求，常常在别人开口之前就递上了他们需要的东西。你相信付出本身就是回报，看到别人因你而展露笑容，就是你最大的满足。你是朋友圈里的'妈妈'角色，永远有一个温暖的怀抱和一句'没关系，有我在'。",
    alienation: "当照顾变成控制的伪装，你开始用'我都是为你好'来绑架他人的选择。你无法接受别人拒绝你的好意，因为那意味着你'不被需要'。你在付出中积累隐形的账单，期待着某天能被同等偿还，却从不把这期待说出口。你照顾所有人，唯独忘了自己也需要被照顾。直到某天你精疲力竭，才发现自己已经空了很久。",
    vacation: "预约一次专业的全身按摩，全程不看手机，不想任何人的事情。练习一整天对所有请求说'让我考虑一下'，而不是立刻答应。找一个你一直在'照顾'的人，认真问他：'你觉得我有什么需要帮助的地方吗？'然后真的让他帮你做一件事。",
  },
  jester: {
    name: "弄臣",
    planet: "妊神星",
    planetImg: "/images/planets/haumea.png",
    color: "#e8a84c",
    feature: "你是太阳系中最奇特的存在——一颗橄榄球形状的矮行星，快速自转让你永远保持着动感。你是天生的气氛担当，能在最尴尬的场合找到笑点，用幽默化解紧张。你相信生活已经够沉重了，何必再给它加码？你的存在提醒着周围的人：别把自己太当回事，世界不会因为你皱眉就停止转动。你是派对的灵魂，是低气压时的解药。",
    alienation: "当幽默成为逃避的盾牌，你开始用笑话堵住所有通向内心的入口。有人想认真和你谈谈，你用一个段子岔开话题；自己难过的时候，你发一条搞笑动态假装没事。你嘲讽一切深刻的东西，因为深刻意味着要面对那些你不想面对的情绪。渐渐地，你成了一个'有趣的人'，却没有人真正了解你。你在人群中央，却感到前所未有的孤独。",
    vacation: "给一个重要的人写一封不搞笑的手写信，认真表达你对他的感谢或歉意。找一本薄薄的哲学入门书或者一部探讨人生意义的电影，允许自己被触动，允许自己流泪。下次有人问'你还好吗'的时候，试着真实地回答，而不是说'好得不得了'。",
  },
  everyman: {
    name: "凡人",
    planet: "谷神星",
    planetImg: "/images/planets/ceres.png",
    color: "#7a7a8a",
    feature: "你是小行星带中最大的天体，不张扬却稳定地存在着。你追求的不是出人头地，而是真实的连接和归属感。你是朋友圈里最好相处的那个人，不端着、不装、不让人有压力。你相信平凡中自有力量，不是每个人都要成为太阳，做一颗温暖的小行星也很好。你的存在让周围的人感到安心：'有你在，就觉得踏实。'",
    alienation: "当对归属的渴望变成对独特的恐惧，你开始过度迎合群体，磨平自己所有的棱角。你害怕发表不同意见，因为那可能让你'不合群'。你的口头禅变成了'都行''随便''你们定'，却在深夜独自后悔那些没说出口的想法。你如此努力地融入，却在这个过程中渐渐失去了自己。最后你发现，你属于每一个群体，却不属于自己。",
    vacation: "报名一次单人徒步或旅行，不带任何社交目的，只是和自己待着。在下一次聚会中，坚持表达一个可能不被认同的真实观点，观察会发生什么。列出5件'只有你会喜欢但朋友们可能觉得奇怪'的事情，这周做其中一件，不解释、不道歉。",
  },
  creator: {
    name: "创造者",
    planet: "天王星",
    planetImg: "/images/planets/uranus.png",
    color: "#6ac4c4",
    feature: "你是太阳系中最特立独行的行星，侧躺着绕太阳运行，用独特的姿态宣告着你的与众不同。你脑海中永远有新点子在碰撞，看到一张白纸就想在上面画点什么，听到一段旋律就想给它填词。你相信创造是人类最接近神的时刻，而你的使命就是把脑海中的世界变成现实。你不满足于'够用就好'，因为你知道，'更好'永远是可能的。",
    alienation: "当创造变成执念，你开始为了不同而不同。你鄙视一切'主流'的东西，却没意识到这种鄙视本身也是一种随波逐流。你的作品越来越晦涩，因为你觉得'被理解'是一种妥协。你在自己的创作宇宙里越走越远，回头却发现没有人跟上来。你成了一座孤岛，风景独特，却无人欣赏。",
    vacation: "找一件经典的、'俗气'的作品，认真临摹或模仿它，并大方承认'这是模仿'。把你最近的一个创作想法讲给一个完全不懂这个领域的朋友听，根据他的反馈修改。去一个热闹的市集或商场，观察那些'普通人'喜欢的东西，试着理解它们为什么受欢迎。",
  },
  ruler: {
    name: "统治者",
    planet: "木星",
    planetImg: "/images/planets/jupiter.png",
    color: "#d4944a",
    feature: "你是太阳系中最大的行星，质量是其他所有行星总和的2.5倍，强大的引力场影响着整个星系的运行。你天生具有领导气质，能在混乱中建立秩序，在迷茫中指明方向。你不害怕做决定，也不害怕为决定负责。你相信好的领导不是控制，而是让每个人都能发挥最大的价值。你的存在让团队有了主心骨：'跟着你，我们知道该往哪走。'",
    alienation: "当领导欲变成控制欲，你开始无法容忍任何'不按计划进行'的事情。你用'为你好'包装你的独断，用'我负责'堵住所有不同的声音。你的团队越来越沉默，因为他们知道说什么都没用。你坐在权力的中心，却感到一种奇怪的空虚——所有人都在听你的，但没有人真的在和你说话。你赢得了服从，却失去了信任。",
    vacation: "策划一次'盲选旅行'，目的地、行程、餐厅全部由朋友或家人决定，你只负责跟着走。在下一个团队项目中，刻意后退一步，让别人来主导，你只提供支持。找一件你一直想让别人按你的方式做的事情，这次完全放手，看看会发生什么。",
  },
  sage: {
    name: "智者",
    planet: "土星",
    planetImg: "/images/planets/saturn.png",
    color: "#a4946a",
    feature: "你被壮丽的冰晶光环环绕，那是亿万年时光沉淀的智慧结晶。你对世界有着永不满足的好奇心，相信每个问题都有答案，而找到答案是人生最大的乐趣。你是朋友圈里的'百科全书'，总能在关键时刻提供有价值的见解。你不轻易下结论，因为你知道真相往往比表象复杂得多。你的存在提醒着周围的人：慢下来，想一想，事情可能不是你以为的那样。",
    alienation: "当追求真理变成智识的傲慢，你开始用理性审判一切。你无法理解为什么有人会'不讲道理'，为什么有人会'明知故犯'。你压抑自己的情感，因为情感是'不理性'的；你疏远那些'不够聪明'的人，因为和他们交流'浪费时间'。你的世界变得越来越小，只剩下书本和理论，却忘了智慧的终点是理解人，而不是评判人。",
    vacation: "找一部完全无厘头的荒诞喜剧，不分析、不解读，就是单纯地看，允许自己笑出声。和一个你觉得'想法简单'的人深入聊一次天，带着真诚的好奇心去理解他的世界。做一件完全'不理性'的事情：比如买一件没用但好看的东西，或者在雨天出门散步。",
  },
  explorer: {
    name: "探索者",
    planet: "阋神星",
    planetImg: "/images/planets/eris.png",
    color: "#5a6a9a",
    feature: "你是太阳系最遥远的矮行星之一，在冥王星轨道之外孤独地运行。你天生向往远方，'这里'永远不如'那里'有吸引力。你不是逃避现实，而是相信世界如此广阔，不应该把自己局限在一个角落。你是朋友圈里最有故事的人，每次见面都有新的经历可以分享。你的存在提醒着周围的人：舒适区之外，还有无限可能。",
    alienation: "当探索变成逃避的借口，你开始用'在路上'来回避所有需要停下来面对的问题。你害怕承诺，因为承诺意味着停留；你害怕深入，因为深入意味着可能会失望。你收集了无数的'体验'，却没有一段真正深刻的关系。你去过很多地方，却不知道哪里是'家'。你一直在寻找，却忘了问自己：到底在找什么？",
    vacation: "选一家你常路过但从未进去的咖啡馆，在同一个位置坐一整天，观察窗外同一条街道的变化。在你现在居住的城市，像游客一样认真逛一次，发现那些你从未注意过的角落。给一段你一直'保持距离'的关系一个深入的机会，看看'停留'会带来什么。",
  },
  innocent: {
    name: "天真者",
    planet: "土卫二",
    planetImg: "/images/planets/enceladus.png",
    color: "#a4c4d4",
    feature: "你是土星最明亮的卫星，冰壳之下藏着温暖的海洋，是太阳系中最可能存在生命的地方之一。你对世界保持着孩子般的信任和好奇，相信人性本善，相信一切都会好起来。你不是天真到看不见黑暗，而是选择相信光明更值得关注。你是朋友圈里的'小太阳'，你的乐观具有感染力，让身边的人也不自觉地相信：也许，事情真的没那么糟。",
    alienation: "当乐观变成对现实的逃避，你开始拒绝承认任何负面的存在。有人向你倾诉痛苦，你急着说'往好处想'；面对明显的问题，你坚持'会好的会好的'。你害怕看到人性的阴暗面，因为那会动摇你世界观的根基。你把自己包裹在粉色泡泡里，却不知道这个泡泡正在让你与真实的世界越来越远。当泡泡破裂的那天，你可能会比任何人都更难接受。",
    vacation: "选一部评价很高但结局不完美的电影，完整看完，不看任何解析或'隐藏彩蛋'，就让那个不完美停在那里。和一个你信任的朋友聊聊你生活中真实存在的一个问题，不急着找解决方案，就只是承认'这件事确实很难'。读一本关于人性复杂性的书，允许自己对世界的看法变得更立体。",
  },
};

export const archetypeOrder = [
  'ruler', 'hero', 'sage', 'explorer', 'outlaw', 'magician',
  'creator', 'lover', 'caregiver', 'jester', 'everyman', 'innocent'
];
